import React from "react";

import { TitleCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function title({ width, onResize }: Column.Options) {
	return base(ColumnId.Title, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default title;
